export default __webpack_public_path__ + "static/home-graphic-green-7f87b191f819d6ab771fa2f2c8646f13.webp";